import type { FunctionComponent } from 'react';

import type { SvgFileProps } from './types';

export const AbbFile: FunctionComponent<SvgFileProps & { isDarkTheme?: boolean }> = ({
  fill = '#000000',
  textColor = '#ffffff',
  backgroundTextColor = '#000000',
  value = 'txt',
  size = 44,
  isDarkTheme = false,
  ...props
}) => {
  const fillColorByTheme = isDarkTheme ? '#ffffff' : '#000000';
  return (
    <svg viewBox='0 0 44 44' width={size} height={size} xmlns='http://www.w3.org/2000/svg' {...props}>
      <path
        d='M31.919 1.83301H7.33398V42.1663H40.334V10.248L31.919 1.83301ZM36.6673 38.4997H11.0007V5.49967H30.4157L36.6673 11.7513V38.4997Z'
        fill={fillColorByTheme}
      />
      <path d='M29.1791 2.95338L38.8515 13.5969H29.1791V2.95338Z' fill={fillColorByTheme} />
      <rect x='2' y='17' width='29' height='16' fill={backgroundTextColor} />
      <text x='4' y='29' style={{ fontFamily: 'Arial', fontWeight: 'bold', fill: textColor, fontSize: '8px', margin: '0 auto' }}>
        {value}
      </text>
    </svg>
  );
};
